import axios from 'axios';


const handleOpenViewer = async (accountId, patientName, setViewerUrl, studyId, user, viewerLink) => {
  setViewerUrl(viewerLink);

  axios.post('/external/insertResultsPortalLogs', {
    type: 'resultsPortal',
    subType: 'studyViewerResults',
    studyId,
    patientName,
    accountId,
    user: {
      username: user.username,
      typeUser: user.type === 'medico'
        ? 'Médico solicitante'
        : user.type === 'paciente' ? 'Paciente' : 'Prestador'
    }
  });
};

export default handleOpenViewer;